export class NetworkAdapter {
    constructor(config) {
        this.config = config;
    }

    async request(url, options) {
        throw new Error('NetworkAdapter.request must be implemented');
    }
}

export class WebNetworkAdapter extends NetworkAdapter {
    async request(url, options) {
        return this.config.fetch(url, options);
    }
}

export class NativeNetworkAdapter extends NetworkAdapter {
    async request(url, options) {
        return this.config.fetch(url, {
            ...options,
            headers: {
                ...options.headers,
                'X-Platform': 'react-native',
            }
        });
    }
}
